<template>
  <router-view />
</template>

<script>
export default {
  name: 'CommonIndex'
}
</script>
